import React from 'react'

const SupportUs = () => {
    return (
        <div className='supportus'>
            <p >For support, contact us at:</p>
            <a href="mailto:support@econometrica.com">support@econometrica.com</a>
        </div>
    )
}

export default SupportUs